/* eslint-disable @faire/no-match-media */
import { getWindow } from "@faire/web/common/globals/getWindow";
import { MIN_WIDTH_BREAKPOINTS } from "@faire/web/common/media";

export const viewport = {
  sm: () => getWindow()?.matchMedia(mediaQuery.sm),
  md: () => getWindow()?.matchMedia(mediaQuery.md),
  lg: () => getWindow()?.matchMedia(mediaQuery.lg),
  xl: () => getWindow()?.matchMedia(mediaQuery.xl),
  xxl: () => getWindow()?.matchMedia(mediaQuery.xxl),
};

const mediaQuery = {
  sm: `(max-width: ${MIN_WIDTH_BREAKPOINTS.TABLET - 1}px)`,
  md: `(min-width: ${MIN_WIDTH_BREAKPOINTS.TABLET}px) and (max-width: ${MIN_WIDTH_BREAKPOINTS.DESKTOP - 1}px)`,
  lg: `(min-width: ${MIN_WIDTH_BREAKPOINTS.DESKTOP}px) and (max-width: ${MIN_WIDTH_BREAKPOINTS.XLARGE - 1}px)`,
  xl: `(min-width: ${MIN_WIDTH_BREAKPOINTS.XLARGE}px) and (max-width: ${MIN_WIDTH_BREAKPOINTS.XXLARGE - 1}px)`,
  xxl: `(min-width: ${MIN_WIDTH_BREAKPOINTS.XXLARGE}px)`,
};
